import styled from "styled-components";

export const WrappedButtonArea = styled.div`
  min-height: 132px;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    min-height: 96px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    min-height: 96px;
  }
`;

interface IChildrenAreaProps {
  $fullWidth?: boolean;
  $intenseGradient: boolean;
}

export const ChildrenArea = styled.div<IChildrenAreaProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 24px 16px;
  bottom: 0;
  background: ${({ $intenseGradient }) =>
    `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff ${$intenseGradient ? "15%" : "45%"})`};
  width: 100%;
  padding: 24px 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "330px")};
  }
`;

export const InnerChildrenArea = styled.div<{ $fullWidth?: boolean; $btnUseOnly?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "342px")};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "336px")};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "330px")};
  }
`;
